import { Component } from '@angular/core';
import { IconsComponent } from '../icons/icons.component';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-premium-user',
  standalone: true,
  imports: [CommonModule, IconsComponent],
  template: `<div>
    <img
      src="../../../assets/images/editorimages/premium-user-animation.webp"
      alt=""
    />
    <p>You're close! Unlock Premium tips to make the final difference.</p>
    <a href="/pricing" target="_blank">
      <app-icons name="premiumDiamondIcon" />
      <span>Upgrade to Pro</span>
    </a>
  </div>`,
  styles: [
    `
      div {
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        align-items: center;
        background: linear-gradient(180deg, #f5fff2 23.33%, #d9f2e4 100%);
        gap: 1rem;
        border-radius: 5px;
        padding: 0.5rem 0.65rem;
        border: 1px solid #d6f2e2;
      }
      img {
        grid-column: span 2;
        width: 100%;
      }
      p {
        grid-column: span 6;
        margin: 0;
        font-size: 0.95rem;
        color: var(--editor-dark);
      }
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        grid-column: span 4;
        color: #fff;
        background-color: var(--editor-dark);
        border: none;
        border-radius: 0.3rem;
        padding: 0.5rem;
        transition: 0.3s ease;
      }

      span {
        font-size: 0.9rem;
      }

      a:hover {
        text-decoration: none;
        background-color: var(--editor-black);
      }
    `,
  ],
})
export class PremiumUserComponent {}
